import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row page-max-width q-mx-auto" }
const _hoisted_2 = { class: "table-cell q-pr-sm" }
const _hoisted_3 = { class: "table-cell" }
const _hoisted_4 = { class: "table-cell q-pr-sm" }
const _hoisted_5 = { class: "table-cell" }
const _hoisted_6 = { class: "table-cell q-pr-sm" }
const _hoisted_7 = { class: "table-cell" }
const _hoisted_8 = { class: "table-cell q-pr-sm" }
const _hoisted_9 = { class: "table-cell" }
const _hoisted_10 = { class: "table-cell q-pr-sm" }
const _hoisted_11 = { class: "table-cell" }
const _hoisted_12 = { class: "table-cell q-pr-sm" }
const _hoisted_13 = { class: "table-cell" }

import { ref, onBeforeMount, computed } from 'vue';

// Personal components
import QPageTitle from '@components/QPageTitle.vue';
import QChangelogItem from '@components/QChangelogItem.vue';

// Stores
import { useUiStore } from '@stores/ui';

// ViewModel
import { useGlobalVM } from '@viewmodel/global.vm';

// Personal libs
import { IBackendDate, IChangelog, IRelease } from '@shared/interface/model.interface';
import {
  convertBackendDateToDate,
  convertDateToSimpleDate,
} from '@shared/lib/date.lib';
import releaseRepository from '@data/repository/changelog.repository';
import { RepositoryStrategyEnum } from '@shared/enum/repository-strategy.enum';
import { ChangelogEnum } from '@shared/enum/changelog.enum';

interface IMajorVersion {
  version: string;
  date: IBackendDate;
  releases: Array<IRelease>;
}

/**
 * Viewmodel
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'ChangelogPage',
  setup(__props) {

// Vendor
const { isMobile } = useGlobalVM();

/**
 * Stores
 */
const uiStore = useUiStore();

/**
 * Reactive datas
 */
const tab = ref<string | undefined>('');
const localVersion = ref<string | undefined>();
const releases = ref<IRelease[] | undefined>([]);
const versions = ref<Array<IMajorVersion> | undefined>([]);
const loading = ref<boolean>(false);

/**
 * Computed
 */
const localCurrentVersion = computed<string>(() => process.env.FRONTEND.currentVersion ?? '')

/**
 * Methods
 */
function convertDate(backendDate: IBackendDate): string {
  return convertDateToSimpleDate(convertBackendDateToDate(backendDate));
}

function convertVersion(version: string) {
  // return replaceAll(version, '.', '-');
  const t = version.split('.');
  return `${parseInt(t[0])}.${parseInt(t[1])}.${parseInt(t[2])}`;
}

function getMajorVersion(version: string): string {
  return version.substring(0, version.lastIndexOf('.'));
}

function constructMajorVersionArray() {
  let tempMajorVersion = '';
  uiStore.releases?.forEach((release) => {
    const majorVersion = getMajorVersion(release.version);
    if (majorVersion !== tempMajorVersion) {
      tempMajorVersion = majorVersion;

      versions.value?.push({
        version: tempMajorVersion,
        date: release.deployedAt,
        releases: [release],
      });
    } else {
      if (versions.value) {
        versions.value = versions.value.map((version) => {
          if (version.version == majorVersion) {
            version.releases.push(release);
          }
          return version;
        });
      }
    }
  });
}

/**
 * Hooks
 */
localVersion.value = `${process.env.FRONTEND.currentVersion}`;

constructMajorVersionArray();

// Active last version tab
tab.value = getMajorVersion(localVersion.value);

onBeforeMount(() => {
  loading.value = true;

  releaseRepository
    .getChangelog(RepositoryStrategyEnum.NETWORK_FIRST)
    .then((changelog?: IChangelog) => {
      releases.value = changelog?.releases;
    })
    .finally(() => (loading.value = false));
});

return (_ctx: any,_cache: any) => {
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!
  const _component_q_timeline_entry = _resolveComponent("q-timeline-entry")!
  const _component_q_timeline = _resolveComponent("q-timeline")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(QPageTitle, { title: 'Notes de version' }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_q_inner_loading, { showing: loading.value }, {
        default: _withCtx(() => [
          _createVNode(_component_q_spinner, {
            size: "100px",
            color: "primary"
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["showing"]),
      _createVNode(_component_q_timeline, {
        color: "secondary",
        class: _normalizeClass(_unref(isMobile) ? 'q-mx-sm' : ''),
        layout: _unref(isMobile) ? 'dense' : 'comfortable'
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(releases.value, (release, index1) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (localCurrentVersion.value >= release.version)
                ? (_openBlock(), _createBlock(_component_q_timeline_entry, {
                    key: index1,
                    title: `Version ${convertVersion(release.version)} (${convertDate(
            release.deployedAt,
          )})`
                  }, {
                    default: _withCtx(() => [
                      _createCommentVNode(" Added "),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(release.added, (added, index2) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index2,
                          class: "table-row"
                        }, [
                          _createElementVNode("div", _hoisted_2, [
                            _createVNode(QChangelogItem, {
                              "changelog-type": _unref(ChangelogEnum).ADDED
                            }, null, 8 /* PROPS */, ["changelog-type"])
                          ]),
                          _createElementVNode("div", _hoisted_3, _toDisplayString(added), 1 /* TEXT */)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */)),
                      _createCommentVNode(" Changed "),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(release.changed, (changed, index2) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index2,
                          class: "table-row"
                        }, [
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(QChangelogItem, {
                              "changelog-type": _unref(ChangelogEnum).CHANGED
                            }, null, 8 /* PROPS */, ["changelog-type"])
                          ]),
                          _createElementVNode("div", _hoisted_5, _toDisplayString(changed), 1 /* TEXT */)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */)),
                      _createCommentVNode(" Fixed "),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(release.fixed, (fixed, index2) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index2,
                          class: "table-row"
                        }, [
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(QChangelogItem, {
                              "changelog-type": _unref(ChangelogEnum).FIXED
                            }, null, 8 /* PROPS */, ["changelog-type"])
                          ]),
                          _createElementVNode("div", _hoisted_7, _toDisplayString(fixed), 1 /* TEXT */)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */)),
                      _createCommentVNode(" Security "),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(release.security, (security, index2) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index2,
                          class: "table-row"
                        }, [
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(QChangelogItem, {
                              "changelog-type": _unref(ChangelogEnum).SECURITY
                            }, null, 8 /* PROPS */, ["changelog-type"])
                          ]),
                          _createElementVNode("div", _hoisted_9, _toDisplayString(security), 1 /* TEXT */)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */)),
                      _createCommentVNode(" Deprecated "),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(release.deprecated, (deprecated, index2) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index2,
                          class: "table-row"
                        }, [
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(QChangelogItem, {
                              "changelog-type": _unref(ChangelogEnum).DEPRECATED
                            }, null, 8 /* PROPS */, ["changelog-type"])
                          ]),
                          _createElementVNode("div", _hoisted_11, _toDisplayString(deprecated), 1 /* TEXT */)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */)),
                      _createCommentVNode(" Removed "),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(release.removed, (removed, index2) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index2,
                          class: "table-row"
                        }, [
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(QChangelogItem, {
                              "changelog-type": _unref(ChangelogEnum).REMOVED
                            }, null, 8 /* PROPS */, ["changelog-type"])
                          ]),
                          _createElementVNode("div", _hoisted_13, _toDisplayString(removed), 1 /* TEXT */)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title"]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["class", "layout"])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})